import React from "react";

import { Card, Typography } from "antd";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import moment from "moment";

import "./styles.scss";

const { Title } = Typography;

const CustomCard = ({ data,onEdit,onView }) =>{ 
  return(
  <Card
    style={{
      width: 300,
    }}
  >
    <img src={data.image || data.photo_url} style={{ height: 160, width: '100%' }} />
    <div style={{ textAlign: "left", padding: 12 }}>
      <div className="menu-container">
        <div>
          <Title level={4}>{data?.name || 'Catering Menu'}</Title>
        </div>
        <div>
          <EditOutlined className="menu-icon" onClick={onEdit}/>
          <EyeOutlined className="menu-icon" onClick={()=>onView(data.id)}/>
        </div>
      </div>
      <div className="theme-red">{'Last updated at ' +moment(data?.updated_at).utc().format('DD MMM , YYYY')}</div>
      <div className="menu-name">Savage Burrito - Fort Worth </div>
    </div>
  </Card>
);
  }
export default CustomCard;
